import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BannerUpdate from '../BannerUpdate/BannerUpadate';
import './QuestionPaper.css';
import API_URL from '../../api/ExamCalendarApi';

const QuestionPaper = () => {
  const [questionPapers, setQuestionPapers] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    pdf: null,
  });
  const [editPaperId, setEditPaperId] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // Fetch all question papers
  const fetchQuestionPapers = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/pqna/all`);
      setQuestionPapers(response.data);
    } catch (error) {
      setErrorMessage('Failed to fetch question papers.');
      console.error('Error fetching question papers:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchQuestionPapers();
  }, []);

  // Handle form changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: files ? files[0] : value,
    }));
  };

  // Handle form submit (Add or Update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formPayload = new FormData();
    formPayload.append('title', formData.title);
    if (formData.pdf) {
      formPayload.append('pdf', formData.pdf);
    }

    try {
      if (editPaperId) {
        await axios.put(`${API_URL}/pqna/edit/${editPaperId}`, formPayload);
        setEditPaperId(null);
      } else {
        await axios.post(`${API_URL}/pqna/add`, formPayload);
      }
      setFormData({ title: '', pdf: null });
      await fetchQuestionPapers();
    } catch (error) {
      setErrorMessage('Failed to save question paper.');
      console.error('Error saving question paper:', error);
    }
    setLoading(false);
  };

  // Handle delete question paper
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this question paper?')) {
      setLoading(true);
      try {
        await axios.delete(`${API_URL}/pqna/delete/${id}`);
        await fetchQuestionPapers();
      } catch (error) {
        setErrorMessage('Failed to delete question paper.');
        console.error('Error deleting question paper:', error);
      }
      setLoading(false);
    }
  };

  // Handle edit question paper
  const handleEdit = (paper) => {
    setEditPaperId(paper._id);
    setFormData({
      title: paper.title,
      pdf: null, // Reset file input for editing
    });
  };

  return (
    <div className="admin-questionpaper-container">
      <div className="admin-questionpaper-section">
        <h2 className="admin-questionpaper-title">Previous Question Papers Management</h2>
        <BannerUpdate pageName="previousqna" />

        {errorMessage && <div className="admin-questionpaper-error">{errorMessage}</div>}

        <form onSubmit={handleSubmit} className="admin-questionpaper-form">
          <div className="admin-questionpaper-form-group">
            <label className="admin-questionpaper-label">Title</label>
            <input
              type="text"
              name="title"
              className="admin-questionpaper-input"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>

          <div className="admin-questionpaper-form-group">
            <label className="admin-questionpaper-label">Upload PDF</label>
            <input
              type="file"
              name="pdf"
              className="admin-questionpaper-input"
              onChange={handleChange}
              required={!editPaperId} // PDF is required for new question papers
            />
          </div>

          <button type="submit" className="admin-questionpaper-button">
            {editPaperId ? 'Update Question Paper' : 'Add Question Paper'}
          </button>
        </form>

        {loading ? (
          <div className="admin-questionpaper-loading">Loading...</div>
        ) : (
          <>
            <h4 className="admin-questionpaper-subtitle">All Question Papers</h4>
            <div className="admin-questionpaper-table-wrapper">
            <table className="admin-questionpaper-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>PDF Link</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {questionPapers.map((paper) => (
                  <tr key={paper._id}>
                    <td>{paper.title}</td>
                    <td>
                      <a href={paper.pdfLink} target="_blank" rel="noopener noreferrer">
                        View PDF
                      </a>
                    </td>
                    <td className="admin-questionpaper-actions">
                      <button
                        className="admin-questionpaper-edit"
                        onClick={() => handleEdit(paper)}
                      >
                        Edit
                      </button>
                      <button
                        className="admin-questionpaper-delete"
                        onClick={() => handleDelete(paper._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default QuestionPaper;